import { WorkflowTaskStatusToPillVariantMap } from "#src/batteries-included-components/Panels/TablePanels/WorkflowsTablePanel/WorkflowsTablePanel.helpers";
import { IconLoading, Pill } from "@validereinc/common-components";
import {
  SystemActionType,
  SystemActionTypeType,
  WorkflowTaskStatus,
  WorkflowTaskType,
} from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import React from "react";

export const WorkflowStepStatusPill = ({
  workflowStep,
  isLoading,
  shouldShowIcon,
}: {
  workflowStep: WorkflowTaskType;
  isLoading?: boolean;
  shouldShowIcon: boolean;
}) => {
  const isStepSystemAction = Object.values(SystemActionType).includes(
    workflowStep.type as SystemActionTypeType
  );

  const isSystemActionRunning = (() => {
    if (!isStepSystemAction) {
      return false;
    }
    return workflowStep.status === WorkflowTaskStatus.OPEN;
  })();

  return (
    <Pill
      variant={
        WorkflowTaskStatusToPillVariantMap[workflowStep.status] || "default"
      }
      iconLeft={
        shouldShowIcon && isSystemActionRunning ? (
          <IconLoading
            speed="slow"
            size={12}
          />
        ) : null
      }
      isLoading={isLoading}
    >
      {isSystemActionRunning
        ? "Running"
        : toTitleCaseString(workflowStep.status, {
            intent: "ui",
            exceptions: ["oil-and-gas"],
          })}
    </Pill>
  );
};
